import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import {isDraftOrRejected} from 'ag-common/tools/fileStatus'
import {format} from 'ag-common/facades'
import Text from '#components/a/Text'
import UserInfoHOC from '#components/HOC/UserInfoHOC'

export function AuthorInfo(props) {
  const {hasChanges, isSaving, status, lastStatusChange, isAuthor, userInfo, error} = props

  function append(text, info) {
    if (!text) {
      return info
    }
    return `${text} | ${info}`
  }

  let text = ''
  if (lastStatusChange !== undefined) {
    text = `${i18n.t('lastStatusChange_prefix')} ${format(new Date(lastStatusChange), 'dd.MM.yyyy')}`
  }

  if (!isAuthor && userInfo) {
    text = append(text, `${userInfo.lastname}, ${userInfo.firstname}`)
  }

  if (isAuthor && isDraftOrRejected(status)) {
    if (isSaving) {
      text = append(text, i18n.t('misc_saving_pending'))
    } else if (!hasChanges) {
      text = append(text, i18n.t('misc_saving_finished'))
    }
  }

  return <Text text={error || text} />
}

AuthorInfo.propTypes = {
  status: PropTypes.string.isRequired,
  lastStatusChange: PropTypes.string,
  isAuthor: PropTypes.bool.isRequired,
  userInfo: PropTypes.object,
  hasChanges: PropTypes.bool,
  isSaving: PropTypes.bool,
  error: PropTypes.string,
}

export default UserInfoHOC(AuthorInfo)
